<template>
  <!-- grid of registered bills, with filters, pagination  -->

  <div>
    <preload v-if="preload"></preload>
    <nav-bar></nav-bar>
    <nps-indecx></nps-indecx>

    <div style="min-height: 100vh">
      <div class="container contact">
        <div class="row">
          <!-- DESKTOP SCREEN -->
          <div class="col-md-12 class-desktop">
            <p class="page-user">Boletos</p>
            <!-- form filters of registered bills desktop screen -->
            <div style="margin-bottom: 15px; margin-left: -23px">
              <div class="col">
                <button
                    style="background-color: transparent; cursor: pointer"
                    id="collapseFilterHomeMobile"
                    data-toggle="collapse"
                    data-target="#filterinputsdesktop"
                    class="btn accordion-toggle"
                >
                  Filtro <em class="fa fa-chevron-down icon-chevron"></em>
                </button>
              </div>
              <div class="hiddenRow column">
                <div
                    class="accordian-body collapse"
                    style="margin-left: 30px"
                    id="filterinputsdesktop"
                >
                  <div class="form-group">
                    <form
                        @submit.prevent="getBills"
                        class="has-search"
                        style="margin-top: -20px"
                    >
                      <div class="row">
                        <div :class="billTypes.length ? 'col-md-4' : 'col-md-6'">
                          <label>Beneficiário</label>
                          <input
                              id="homeBeneficiaryBill"
                              type="text"
                              class="form-control"
                              placeholder="Digite o beneficiário"
                              v-model="filters.cedente"
                              min="3"
                          />
                        </div>
                        <div class="col-md-4" v-if="billTypes.length">
                          <label>Tipo de Boleto</label>
                          <select class="form-control select-pp" v-model="filters.cdt_id">
                            <option value="" selected>
                              Selecione
                            </option>
                            <option
                                v-for="type in billTypes"
                                :key="type.cdt_id"
                                :value="type.cdt_id"
                            >
                              {{ type.cdt_descricao }}
                            </option>
                          </select>
                        </div>
                        <div :class="billTypes.length ? 'col-md-4' : 'col-md-6'">
                          <label>Pagador</label>
                          <input
                              id="homePayerBill"
                              type="text"
                              class="form-control"
                              placeholder="Digite o pagador"
                              v-model="filters.sacado"
                              min="3"
                          />
                        </div>
                        <div class="col-md-3">
                          <label> Documento</label>
                          <input
                              id="homeDocumentBill"
                              type="text"
                              class="form-control"
                              placeholder="Digite o documento"
                              v-model="filters.documento"
                              min="3"
                          />
                        </div>
                        <div class="col-md-3 ipad-style">
                          <label>Nosso Número</label>
                          <input
                              id="homeOurNumberBill"
                              type="text"
                              class="form-control"
                              placeholder="Digite o número"
                              v-model="filters.nosso_numero"
                              min="3"
                          />
                        </div>
                        <div class="col-md-3">
                          <label>Vencimento inicial</label>
                          <input
                              id="homeInitalDateBill"
                              type="date"
                              class="form-control"
                              placeholder="Data inicial"
                              v-model="filters.vencimento_inicial"
                              :max="blockDateAfter"
                              @change="updateBlockDate"
                          />
                        </div>
                        <div class="col-md-3">
                          <label>Vencimento final</label>
                          <input
                              id="homeFinalDateBill"
                              type="date"
                              class="form-control"
                              placeholder="Data final"
                              v-model="filters.vencimento_final"
                              :min="blockDateBefore"
                              @change="updateBlockDate"
                          />
                        </div>
                        <div class="col-md-3" v-if="groupFilters.filtroMensagem && groupFilters.filtroMensagem === 'S'">
                          <label>Mensagem do boleto</label>
                          <input
                              id="homeMessageBill"
                              type="text"
                              class="form-control"
                              placeholder="Digite a mensagem"
                              v-model="filters.mensagem"
                              min="3"
                          />
                        </div>
                        <div class="col status-filter">
                          <button
                              class="btn btn-lg access-filter"
                              id="homeSearchBill"
                              type="button"
                              @click="clearFilter()"
                          >
                            Limpar
                          </button>
                          <button
                              class="btn btn-lg access-filter"
                              style="margin-left: 10px"
                              id="homeSearchBillClear"
                              type="submit"
                              @click="clearSelectCheck()"
                          >
                            Pesquisar
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <!-- table of registered bills desktop screen -->
            <div>
              <div
                  class="btn-group"
                  style="margin-bottom: 10px"
                  role="group"
                  aria-label="Basic example"
              >
                <button
                    type="button"
                    id="homeBtnFilterOne"
                    class="btn btn-filter"
                    style="
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                  "
                    :class="{ 'btn-checked': buttonChecked == 'a_vencer' }"
                    @click="btnFilters('a_vencer')"
                    title="Clique para listar os boletos com vencimento futuro"
                >
                  A vencer
                </button>
                <button
                    id="homeBtnFilterTwo"
                    type="button"
                    class="btn btn-filter"
                    :class="{ 'btn-checked': buttonChecked == 'vencido' }"
                    @click="btnFilters('vencido')"
                    title="Clique para listar os boletos com vencimento anterior a hoje"
                >
                  Vencidos
                </button>

                <button
                    id="homeBtnFilterThree"
                    type="button"
                    class="btn btn-filter"
                    v-if="userLogged.exibir_situacao_cobrancas"
                    :class="{ 'btn-checked': buttonChecked == 'liquidado' }"
                    @click="btnFilters('liquidado')"
                    title="Clique para listar os boletos já liquidados ou baixados"
                >
                  Liquidados
                </button>

                <button
                    id="homeBtnFilterFive"
                    type="button"
                    class="btn btn-filter"
                    style="
                    border-top-right-radius: 5px;
                    border-bottom-right-radius: 5px;
                  "
                    :class="{ 'btn-checked': buttonChecked == 'todos' }"
                    @click="removeFilter('status')"
                    title="Clique para listar todos os boletos"
                >
                  Todos
                </button>
                <div
                    style="margin-left: 10px; font-size: 12px"
                    v-for="status in filters.status"
                    v-if="!(STATUS_KEY[status] === 'Protestado' && !userLogged.exibir_situacao_cobrancas)"
                    :key="status"
                >
                  <span
                      style="
                      padding-left: 15px;
                      padding-right: 15px;
                      padding-top: 5px;
                      padding-bottom: 5px;
                      color: #fff;
                    "
                      :class="'span_background_' + status"
                  >
                    {{ STATUS_KEY[status] }}
                    <button
                        id="homeBtnFilterStatus"
                        type="button"
                        class="close"
                        style="
                        cursor: pointer;
                        margin: 0px 10px 0px 10px;
                        font-size: 18px;
                      "
                        @click="removeStatus(status)"
                        aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </span>
                </div>
              </div>
              <div class="table-wrapper-scroll-y my-custom-scrollbar">
                <table class="table">
                  <thead style="line-height: 5px">
                  <tr
                      style="
                        background-color: #ebe7e7 !important;
                        font-size: 14px;
                        text-align: center;
                      "
                  >
                    <th></th>

                    <th style="padding-bottom: 0px">
                      <label
                      ><input type="checkbox" v-model="selectAll"
                      /></label>
                    </th>
                    <th style="padding-bottom: 12px" v-if="haveActionsTd">
                      Ações
                    </th>
                    <th @click="sort('num_docto')">
                      Documento<em
                        class="fa fa-sort-down"
                        v-if="filters.order_by == 'num_docto;asc'"
                    ></em
                    ><em
                        class="fa fa-sort-up"
                        v-if="filters.order_by == 'num_docto;desc'"
                    ></em>
                    </th>
                    <th @click="sort('nosso_numero')">
                      Nosso número<em
                        class="fa fa-sort-down"
                        v-if="filters.order_by == 'nosso_numero;asc'"
                    ></em
                    ><em
                        class="fa fa-sort-up"
                        v-if="filters.order_by == 'nosso_numero;desc'"
                    ></em>
                    </th>
                    <th @click="sort('cod_dt_vencto')">
                      Vencimento<em
                        class="fa fa-sort-down"
                        v-if="filters.order_by == 'cod_dt_vencto;asc'"
                    ></em
                    ><em
                        class="fa fa-sort-up"
                        v-if="filters.order_by == 'cod_dt_vencto;desc'"
                    ></em>
                    </th>
                    <th @click="sort('cod_vl_docto')">
                      Valor<em
                        class="fa fa-sort-down"
                        v-if="filters.order_by == 'cod_vl_docto;asc'"
                    ></em
                    ><em
                        class="fa fa-sort-up"
                        v-if="filters.order_by == 'cod_vl_docto;desc'"
                    ></em>
                    </th>
                    <th @click="sort('is_vencido')">
                      Atraso<em
                        class="fa fa-sort-down"
                        v-if="filters.order_by == 'is_vencido;asc'"
                    ></em
                    ><em
                        class="fa fa-sort-up"
                        v-if="filters.order_by == 'is_vencido;desc'"
                    ></em>
                    </th>
                    <th @click="sort('cst_id')">
                      Situação<em
                        class="fa fa-sort-down"
                        v-if="filters.order_by == 'cst_id;asc'"
                    ></em
                    ><em
                        class="fa fa-sort-up"
                        v-if="filters.order_by == 'cst_id;desc'"
                    ></em>
                    </th>
                    <th @click="sort('sac_inscricao')">
                      Inscrição pagador<em
                        class="fa fa-sort-down"
                        v-if="filters.order_by == 'sac_inscricao;asc'"
                    ></em
                    ><em
                        class="fa fa-sort-up"
                        v-if="filters.order_by == 'sac_inscricao;desc'"
                    ></em>
                    </th>
                    <th @click="sort('sacado')">
                      Pagador<em
                        class="fa fa-sort-down"
                        v-if="filters.order_by == 'sacado;asc'"
                    ></em
                    ><em
                        class="fa fa-sort-up"
                        v-if="filters.order_by == 'sacado;desc'"
                    ></em>
                    </th>
                    <th @click="sort('ced_inscricao')">
                      Inscrição Beneficiário<em
                        class="fa fa-sort-down"
                        v-if="filters.order_by == 'ced_inscricao;asc'"
                    ></em
                    ><em
                        class="fa fa-sort-up"
                        v-if="filters.order_by == 'ced_inscricao;desc'"
                    ></em>
                    </th>
                    <th @click="sort('cedente')">
                      Beneficiário<em
                        class="fa fa-sort-down"
                        v-if="filters.order_by == 'cedente;asc'"
                    ></em
                    ><em
                        class="fa fa-sort-up"
                        v-if="filters.order_by == 'cedente;desc'"
                    ></em>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="bills in boletos" :key="'grid_' + bills.cod_id">
                    <th scope="row"></th>
                    <td>
                      <label
                      ><input
                          style="margin-top: 12px"
                          id="homeCheckboxBill"
                          type="checkbox"
                          v-model="selected"
                          class="align-middle"
                          :value="bills.cod_id"
                      /></label>
                    </td>

                    <td v-if="haveActionsTd">
                      <div style="display: flex; justify-content: center">
                        <button
                            class="btn-pay btn-style td-action"
                            type="button"
                            id="homeGetBillPix"
                            v-if="bills.pixp_boleto"
                            @click="getPix(bills, true)"
                            title="Clique para ver seu Pix"
                        >
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20.893"
                              height="20.893"
                              viewBox="0 0 19.893 19.893"
                              class="icons-action"
                          >
                            <path
                                id="PIX-icon"
                                d="M17.554,142.91H2.339A2.339,2.339,0,0,0,0,145.249v15.214A2.339,2.339,0,0,0,2.339,162.8H17.554a2.339,2.339,0,0,0,2.339-2.339V145.249A2.339,2.339,0,0,0,17.554,142.91Zm-9.369,2.74a2.424,2.424,0,0,1,3.428,0l3.01,3.011h-.33a2.223,2.223,0,0,0-1.572.651l-.049.05-1.6,1.6-.764.764a.439.439,0,0,1-.62,0l-2.459-2.462a2.057,2.057,0,0,0-1.454-.6h-.6Zm3.428,14.417a2.424,2.424,0,0,1-3.428,0l-3.016-3.016h.582a2.132,2.132,0,0,0,1.508-.625l.076-.076,1.591-1.591L9.683,154a.45.45,0,0,1,.635,0l.757.757,1.591,1.591.054.054a2.205,2.205,0,0,0,1.559.646h.348Zm5.494-5.495-1.778,1.778H14.3a1.579,1.579,0,0,1-1.116-.462l-2.35-2.349L10.8,153.5a1.156,1.156,0,0,0-1.595,0l-.039.039-2.35,2.349a1.581,1.581,0,0,1-1.117.462H4.469l-1.778-1.778a2.424,2.424,0,0,1,0-3.428l1.784-1.782h1.2a1.613,1.613,0,0,1,1.141.473l2.316,2.316a1.156,1.156,0,0,0,1.631.1,1.208,1.208,0,0,0,.1-.1l2.312-2.312a1.627,1.627,0,0,1,1.152-.477h.994l1.784,1.784A2.424,2.424,0,0,1,17.108,154.573Z"
                                transform="translate(0 -142.91)"
                                fill="#00bdae"
                            />
                          </svg>
                        </button>

                        <button
                            class="btn-pay btn-style td-action"
                            id="homeDownloadBills"
                            v-if="permissionDownloadBill(bills)"
                            @click="downloadBill(bills)"
                            title="Clique para pegar seu boleto"
                        >
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              version="1.1"
                              class="icons-action"
                              x="0px"
                              y="0px"
                              title="from the Noun Project"
                              width="30.893"
                              height="30.893"
                              viewBox="0 0 100 100"
                              style="
                                enable-background: new 0 0 100 100;
                                margin-bottom: -5px;
                              "
                              xml:space="preserve"
                          >
                              <path
                                  d="M13.2,67.7h-3v-50h3V67.7z M48.2,17.7h-3v50h3V17.7z M34.2,17.7h-3v50h3V17.7z M22.2,17.7h-3v50h3V17.7z M54.7,17.7h-4v50h4  V17.7z M41.7,17.7h-4v50h4V17.7z M27.7,17.7h-4v50h4V17.7z M17.7,17.7h-4v50h4V17.7z M57.7,17.7h-2v50h2V17.7z M44.7,17.7h-2v50h2  V17.7z M36.7,17.7h-2v50h2V17.7z M30.7,17.7h-2v50h2V17.7z M8.7,17.7h-2v50h2V17.7z M62.7,17.7h-4v50h2.4c0-2.6,0.6-5,1.6-7.2V17.7z   M65.7,55.9V17.7h-2v40.9C64.3,57.6,65,56.8,65.7,55.9z M70.7,52.1V17.7h-4v37.2C67.9,53.8,69.2,52.8,70.7,52.1z M73.7,50.9V17.7h-2  v33.9C72.4,51.3,73,51.1,73.7,50.9z M76.7,50.3V17.7h-2v32.9C75.4,50.5,76,50.3,76.7,50.3z M78.7,50.1c0.3,0,0.7,0,1,0.1V17.7h-2  v32.5C78,50.2,78.4,50.1,78.7,50.1z M93.3,67.7c0,8-6.5,14.6-14.6,14.6s-14.6-6.5-14.6-14.6s6.5-14.6,14.6-14.6S93.3,59.7,93.3,67.7  z M85.2,70.2c0-0.4-0.1-0.8-0.4-1.1c-0.6-0.6-1.5-0.6-2.1,0l-2.4,2.4V60.2c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v11.4l-2.4-2.4  c-0.6-0.6-1.5-0.6-2.1,0c-0.6,0.6-0.6,1.5,0,2.1l5,5c0,0,0.1,0.1,0.1,0.1c0.2,0.2,0.5,0.3,0.8,0.4c0.1,0,0.1,0,0.2,0  c0,0,0.1,0,0.1,0c0.4,0,0.7-0.2,1-0.4l5-5C85.1,71,85.2,70.6,85.2,70.2z"
                              />
                            </svg>
                        </button>
                        <div >
                          <button
                              v-if="
                                bills.documento_diverso ||
                                bills.pagamento_parcelado ||
                                permissionDownloadBill(bills)
                              "
                              class="btn-style dropdown td-action"
                              type="button"
                              id="homeDropDownActions"
                              data-toggle="dropdown"
                              title="Clique para mais ações"
                              aria-haspopup="true"
                              aria-expanded="false"
                              width="20.893"
                              height="20.893"
                              style="margin-top: 8px"
                          >
                            <em
                                class="fa fa-ellipsis-v icons-font"
                                style="font-size: 23px"
                            ></em>
                          </button>

                          <div
                              class="dropdown-menu"
                              aria-labelledby="dropDownActions"
                          >
                              <span
                                  class="dropdown-item"
                                  v-if="bills.pagamento_parcelado"
                                  @click="bills.pagamento_parcelado.status !==
                                  'CAPTURADO'
                                    ? openNotificationEmailModal(bills)
                                    : ''
                                "
                                  :title="
                                  bills.pagamento_parcelado.status ===
                                  'CAPTURADO'
                                    ? 'Pagto Aprovado - aguarde a liquidação do título'
                                    : ''
                                "
                              >
                                <button
                                    id="homeDownloadAttachedDocument"
                                    class="btn-style"
                                >
                                  <span>
                                    <em
                                        class="fa fa-credit-card icon-payment"
                                        v-bind:class="{
                                        'credit-payment-green':
                                          bills.pagamento_parcelado.status ===
                                          '',
                                        'credit-payment-yellow':
                                          bills.pagamento_parcelado.status ===
                                          'EM_ANDAMENTO',
                                        'credit-payment-blue':
                                          bills.pagamento_parcelado.status ===
                                          'CAPTURADO',
                                      }"
                                    ></em
                                    ></span>
                                  <span
                                      v-bind:class="{
                                      'credit-payment-green-status':
                                        bills.pagamento_parcelado.status === '',
                                      'credit-payment-yellow-status':
                                        bills.pagamento_parcelado.status ===
                                        'EM_ANDAMENTO',
                                      'credit-payment-blue-status':
                                        bills.pagamento_parcelado.status ===
                                        'CAPTURADO',
                                    }"
                                  >Pagamento com cartão
                                  </span>
                                </button>
                              </span>
                            <a
                                class="dropdown-item"
                                href="#"
                                v-if="permissionDownloadBill(bills)"
                                @click="copyCode(bills.cod_id)"
                            >
                              <button
                                  id="homeCopyCode"
                                  class="btn-style"
                                  style="width: 100%"
                              >
                                <em class="fa fa-copy icons-action"></em>
                                Copiar linha digitável
                              </button>
                            </a
                            >
                            <a
                                class="dropdown-item"
                                href="#"
                                v-if="bills.documento_diverso"
                                @click="downloadDocument(bills.cod_id)"
                            >
                              <button
                                  id="homeDownloadDocument"
                                  class="btn-style"
                              >
                                <em class="fa fa-copy icons-action"></em>
                                Download documento em anexo
                              </button>
                            </a>
                          </div>
                        </div>
                      </div>
                    </td>

                    <td class="align-middle">
                      {{ bills.num_docto }}
                    </td>
                    <td class="align-middle">
                      {{ bills.nosso_numero }}
                    </td>
                    <td class="align-middle">
                      {{ bills.cod_dt_vencto | formatDate }}
                    </td>
                    <td class="align-middle">
                      {{ bills.cod_vl_docto | formatCurrency }}
                    </td>
                    <td class="align-middle" style="text-align: center">
                      <div
                          v-if="
                            bills.is_vencido > 0 &&
                            (bills.cst_id === 2 || bills.cst_id === 8)
                          "
                      >
                        {{ bills.is_vencido }} <span>Dias</span>
                      </div>
                      <div v-else>-</div>
                    </td>
                    <td class="align-middle">
                        <span
                            style="margin-right: 5px; font-size: 7px"
                            :class="'span_background_' + bills.cst_id"
                        >
                        </span>
                      {{ STATUS_KEY[bills.cst_id] }}
                    </td>
                    <td class="align-middle">
                      {{ bills.sac_inscricao | formatCPFCNPJ }}
                    </td>
                    <td class="align-middle">
                      <pre>{{ bills.sacado }} </pre>
                    </td>
                    <td class="align-middle">
                      {{ bills.ced_inscricao | formatCPFCNPJ }}
                    </td>
                    <td class="align-middle">
                      {{ bills.cedente }}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="buttons-footer">
                <!-- pagination of registered bills desktop screen -->

                <div>
                  <button
                      id="homeDownloadBillModal"
                      class="btn btn-lg access"
                      style="margin-right: 5px"
                      type="submit"
                      @click="resetModalDownloadBill"
                      :disabled="!selected.length"
                      title="Selecione os boletos da página para gerar um PDF único"
                  >
                    Download
                  </button>
                  <button
                      id="homeReportsBillModal"
                      class="btn btn-lg access"
                      type="submit"
                      data-toggle="modal"
                      data-target="#billsReportsModal"
                      @click="renderReportsModal += 1"
                      :disabled="!selected.length"
                  >
                    Relatórios
                  </button>
                </div>
                <pagination
                    v-if="pagination.last_page > 1"
                    :pagination="pagination"
                    :offset="5"
                    @paginate="getBills(true)"
                ></pagination>

                <p class="total-page">
                  Total de boletos:
                  <span style="margin-left: 2px">
                    {{ this.pagination.total }}</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- END OF DESKTOP SCREEN -->

        <!-- MOBILE SCREEN -->
        <!-- form filters of registered bills mobile screen -->
        <div class="row justify-content-center class-mobile">
          <div class="">
            <p class="page-user" style="margin-top: -50px">Boletos</p>

            <div style="margin-bottom: 15px; margin-left: -23px">
              <div
                  data-toggle="collapse"
                  data-target="#filterinputs"
                  class="col accordion-toggle"
              >
                <button
                    style="background-color: transparent"
                    id="homeCollapseFilterMobile"
                    class="btn"
                >
                  Filtro <em class="fa fa-chevron-down icon-chevron"></em>
                </button>
              </div>

              <div class="hiddenRow column">
                <div
                    class="accordian-body collapse"
                    style="margin-left: 30px"
                    id="filterinputs"
                >
                  <div class="form-group">
                    <form @submit.prevent="getBills" class="has-search">
                      <div class="row">
                        <div class="col-md-6">
                          <label>Beneficiário</label>
                          <input
                              id="homeBeneficiaryBillMobile"
                              type="text"
                              class="form-control"
                              placeholder="Digite o beneficiário"
                              v-model="filters.cedente"
                              min="3"
                          />
                        </div>
                        <div class="col-md-6" v-if="billTypes.length">
                          <label>Tipo de Boleto</label>
                          <select class="form-control select-pp" v-model="filters.cdt_id">
                            <option value="" selected>
                              Selecione
                            </option>
                            <option
                                v-for="type in billTypes"
                                :key="type.cdt_id"
                                :value="type.cdt_id"
                            >
                              {{ type.cdt_descricao }}
                            </option>
                          </select>
                        </div>
                        <div class="col-md-6">
                          <label>Pagador</label>
                          <input
                              id="homePayerBillMobile"
                              type="text"
                              class="form-control"
                              placeholder="Digite o pagador"
                              v-model="filters.sacado"
                              min="3"
                          />
                        </div>
                        <div class="col-md-3">
                          <label>Número de Documento</label>
                          <input
                              id="homeDocumentBillMobile"
                              type="text"
                              class="form-control"
                              placeholder="Digite o documento"
                              v-model="filters.documento"
                              min="3"
                          />
                        </div>
                        <div class="col-md-3">
                          <label>Nosso Número</label>
                          <input
                              id="homeOurNumberMobile"
                              type="text"
                              class="form-control"
                              placeholder="Digite o número"
                              v-model="filters.nosso_numero"
                              min="3"
                          />
                        </div>
                        <div class="col-md-3">
                          <label>Vencimento inicial</label>
                          <input
                              id="homeInitalDateBillMobile"
                              type="date"
                              class="form-control"
                              placeholder="Data inicial"
                              v-model="filters.vencimento_inicial"
                              :min="filters.vencimento_inicial"
                          />
                        </div>
                        <div class="col-md-3">
                          <label>Vencimento final</label>
                          <input
                              id="homeFinalDateBillMobile"
                              type="date"
                              class="form-control"
                              placeholder="Data final"
                              v-model="filters.vencimento_final"
                              :max="filters.vencimento_final"
                          />
                        </div>
                        <div class="col-md-3" v-if="groupFilters.filtroMensagem && groupFilters.filtroMensagem === 'S'">
                          <label>Mensagem do boleto</label>
                          <input
                              id="homeMessageMobile"
                              type="text"
                              class="form-control"
                              placeholder="Digite a mensagem"
                              v-model="filters.mensagem"
                              min="3"
                          />
                        </div>

                        <div class="form-filter-mobile">
                          <button
                              class="btn btn-lg access-filter"
                              id="homeClearInputs"
                              type="button"
                              @click="clearFilter()"
                          >
                            Limpar
                          </button>
                          <button
                              style="margin-left: 10px"
                              class="btn btn-lg access-filter"
                              id="homeSearchBillMobile"
                              type="submit"
                          >
                            Pesquisar
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div
                class="btn-group"
                style="justify-content: center; display: flex"
                role="group"
                aria-label="Basic example"
            >
              <button
                  id="homeBtnFilterMobileOne"
                  type="button"
                  class="btn btn-filter"
                  v-bind:class="{ 'btn-checked': buttonChecked == 'a_vencer' }"
                  v-on:click="btnFilters('a_vencer')"
              >
                A vencer
              </button>
              <button
                  id="homeBtnFilterMobileTwo"
                  type="button"
                  class="btn btn-filter"
                  v-bind:class="{ 'btn-checked': buttonChecked == 'vencido' }"
                  v-on:click="btnFilters('vencido')"
              >
                Vencidos
              </button>
              <button
                  id="homeBtnFilterMobileThree"
                  type="button"
                  class="btn btn-filter"
                  v-if="userLogged.exibir_situacao_cobrancas"
                  v-bind:class="{ 'btn-checked': buttonChecked == 'liquidado' }"
                  v-on:click="btnFilters('liquidado')"
              >
                Liquidados
              </button>
              <button
                  id="homeBtnFilterMobileFour"
                  type="button"
                  class="btn btn-filter"
                  v-bind:class="{ 'btn-checked': buttonChecked == 'todos' }"
                  v-on:click="removeFilter('status')"
              >
                Todos
              </button>
            </div>
            <!-- table list of registered bills mobile screen -->

            <div
                v-for="bills in boletos"
                :key="'grid_' + bills.cod_id"
                class="principal-div"
            >
              <div class="col col-divs">
                <div style="width: 30%">
                  <label>Documento</label> {{ bills.num_docto }}
                </div>
                <div style="width: 30%">
                  <label>Vencimento</label>
                  {{ bills.cod_dt_vencto | formatDate }}
                </div>
                <div style="width: 30%">
                  <label>Valor</label><br/>
                  {{ bills.cod_vl_docto | formatCurrency }}
                </div>
                <button
                    id="collapseInfosBillMobile"
                    style="width: 15%; background-color: #fff"
                    class="btn accordion-toggle"
                    data-toggle="collapse"
                    :data-target="'#test' + bills.cod_id"
                >
                  <em class="fa fa-chevron-down icon-chevron"></em>
                </button>
              </div>

              <div class="hiddenRow column">
                <div
                    class="accordian-body collapse"
                    :id="'test' + bills.cod_id"
                >
                  <div class="col col-divs">
                    <div style="width: 30%">
                      <label>Status</label><br/>
                      {{ STATUS_KEY[bills.cst_id] }}
                    </div>
                    <div
                        style="width: 30%"
                        v-if="
                        bills.is_vencido > 0 &&
                        (bills.cst_id === 2 || bills.cst_id === 8)
                      "
                    >
                      <label>Atraso</label><br/>
                      {{ bills.is_vencido }}
                    </div>
                    <div style="width: 30%" v-else>
                      <label>Atraso</label><br/>
                      -
                    </div>

                    <div style="width: 30%"></div>
                  </div>

                  <div class="col col-divs">
                    <div style="width: 90%">
                      <label>Beneficiário</label><br/>
                      {{ bills.ced_inscricao | formatCPFCNPJ }} -
                      {{ bills.cedente }}
                    </div>
                  </div>
                  <div class="col col-divs">
                    <div style="width: 90%">
                      <label>Pagador</label><br/>
                      {{ bills.sac_inscricao | formatCPFCNPJ }}
                      {{ bills.sacado }}
                    </div>
                  </div>
                  <hr style="margin-bottom: 0px"/>
                  <div
                      class="col-12"
                      style="
                      display: flex;
                      font-size: 9px;
                      margin-left: -9px;
                      margin-top: 5px;
                    "
                  >
                    <div class="col-6">
                      <div
                          class="row"
                          style="padding-top: 0px"
                          v-if="bills.pixp_boleto"
                      >
                        <button
                            class="btn-pay btn-style"
                            id="homePayBillPixMobile"
                            @click="getPix(bills, true)"
                        >
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20.893"
                              height="20.893"
                              viewBox="0 0 19.893 19.893"
                              class="icons-action"
                          >
                            <path
                                id="PIX-icon"
                                d="M17.554,142.91H2.339A2.339,2.339,0,0,0,0,145.249v15.214A2.339,2.339,0,0,0,2.339,162.8H17.554a2.339,2.339,0,0,0,2.339-2.339V145.249A2.339,2.339,0,0,0,17.554,142.91Zm-9.369,2.74a2.424,2.424,0,0,1,3.428,0l3.01,3.011h-.33a2.223,2.223,0,0,0-1.572.651l-.049.05-1.6,1.6-.764.764a.439.439,0,0,1-.62,0l-2.459-2.462a2.057,2.057,0,0,0-1.454-.6h-.6Zm3.428,14.417a2.424,2.424,0,0,1-3.428,0l-3.016-3.016h.582a2.132,2.132,0,0,0,1.508-.625l.076-.076,1.591-1.591L9.683,154a.45.45,0,0,1,.635,0l.757.757,1.591,1.591.054.054a2.205,2.205,0,0,0,1.559.646h.348Zm5.494-5.495-1.778,1.778H14.3a1.579,1.579,0,0,1-1.116-.462l-2.35-2.349L10.8,153.5a1.156,1.156,0,0,0-1.595,0l-.039.039-2.35,2.349a1.581,1.581,0,0,1-1.117.462H4.469l-1.778-1.778a2.424,2.424,0,0,1,0-3.428l1.784-1.782h1.2a1.613,1.613,0,0,1,1.141.473l2.316,2.316a1.156,1.156,0,0,0,1.631.1,1.208,1.208,0,0,0,.1-.1l2.312-2.312a1.627,1.627,0,0,1,1.152-.477h.994l1.784,1.784A2.424,2.424,0,0,1,17.108,154.573Z"
                                transform="translate(0 -142.91)"
                                fill="#00bdae"
                            />
                          </svg>
                        </button
                        >
                        <span style="margin-top: 10px">Pagar com pix</span>
                      </div>
                      <div
                          class="row"
                          style="padding-top: 0px"
                          v-if="permissionDownloadBill(bills)"
                      >
                        <button
                            class="btn-pay btn-style"
                            id="homeDownloadBillsMobile"
                            style="width: 26% !important; margin-left: -2px"
                            @click="downloadBill(bills)"
                        >
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              version="1.1"
                              class="icons-action"
                              x="0px"
                              y="0px"
                              title="from the Noun Project"
                              width="30.893"
                              height="30.893"
                              viewBox="0 0 100 100"
                              style="enable-background: new 0 0 100 100"
                              xml:space="preserve"
                          >
                            <path
                                d="M13.2,67.7h-3v-50h3V67.7z M48.2,17.7h-3v50h3V17.7z M34.2,17.7h-3v50h3V17.7z M22.2,17.7h-3v50h3V17.7z M54.7,17.7h-4v50h4  V17.7z M41.7,17.7h-4v50h4V17.7z M27.7,17.7h-4v50h4V17.7z M17.7,17.7h-4v50h4V17.7z M57.7,17.7h-2v50h2V17.7z M44.7,17.7h-2v50h2  V17.7z M36.7,17.7h-2v50h2V17.7z M30.7,17.7h-2v50h2V17.7z M8.7,17.7h-2v50h2V17.7z M62.7,17.7h-4v50h2.4c0-2.6,0.6-5,1.6-7.2V17.7z   M65.7,55.9V17.7h-2v40.9C64.3,57.6,65,56.8,65.7,55.9z M70.7,52.1V17.7h-4v37.2C67.9,53.8,69.2,52.8,70.7,52.1z M73.7,50.9V17.7h-2  v33.9C72.4,51.3,73,51.1,73.7,50.9z M76.7,50.3V17.7h-2v32.9C75.4,50.5,76,50.3,76.7,50.3z M78.7,50.1c0.3,0,0.7,0,1,0.1V17.7h-2  v32.5C78,50.2,78.4,50.1,78.7,50.1z M93.3,67.7c0,8-6.5,14.6-14.6,14.6s-14.6-6.5-14.6-14.6s6.5-14.6,14.6-14.6S93.3,59.7,93.3,67.7  z M85.2,70.2c0-0.4-0.1-0.8-0.4-1.1c-0.6-0.6-1.5-0.6-2.1,0l-2.4,2.4V60.2c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v11.4l-2.4-2.4  c-0.6-0.6-1.5-0.6-2.1,0c-0.6,0.6-0.6,1.5,0,2.1l5,5c0,0,0.1,0.1,0.1,0.1c0.2,0.2,0.5,0.3,0.8,0.4c0.1,0,0.1,0,0.2,0  c0,0,0.1,0,0.1,0c0.4,0,0.7-0.2,1-0.4l5-5C85.1,71,85.2,70.6,85.2,70.2z"
                            />
                          </svg>
                        </button
                        >
                        <span style="margin-top: 15px" class="ipad-media"
                        >Download do boleto</span
                        >
                      </div>

                      <div class="row" style="padding-top: 0px">
                        <span
                            class="dropdown-item"
                            style="
                            padding: 0px !important;
                            width: 25%;
                            font-size: 9px;
                          "
                            v-if="bills.pagamento_parcelado"
                            @click="
                            bills.pagamento_parcelado.status !== 'CAPTURADO'
                              ? openNotificationEmailModal(bills)
                              : ''
                          "
                            :title="
                            bills.pagamento_parcelado.status === 'CAPTURADO'
                              ? 'Pagto Aprovado - aguarde a liquidação do título'
                              : ''
                          "
                        >
                          <button
                              v-bind:class="{
                              'credit-payment-green':
                                bills.pagamento_parcelado.status === '',
                              'credit-payment-yellow':
                                bills.pagamento_parcelado.status ===
                                'EM_ANDAMENTO',
                              'credit-payment-blue':
                                bills.pagamento_parcelado.status ===
                                'CAPTURADO',
                            }"
                              id="homePayCardMobile"
                              class="btn-style btn-pay"
                              width="30.893"
                              height="30.893"
                          >
                            <em
                                class="fa fa-credit-card icon-payment"
                                v-bind:class="{
                                'credit-payment-green':
                                  bills.pagamento_parcelado.status === '',
                                'credit-payment-yellow':
                                  bills.pagamento_parcelado.status ===
                                  'EM_ANDAMENTO',
                                'credit-payment-blue':
                                  bills.pagamento_parcelado.status ===
                                  'CAPTURADO',
                              }"
                            ></em></button
                          ><span style="margin-top: 10px"
                        >Pagar com cartão</span
                        >
                        </span>
                      </div>
                    </div>
                    <div class="col-6">
                      <div
                          class="row"
                          style="padding-top: 0px"
                          v-if="permissionDownloadBill(bills)"
                      >
                        <button
                            @click="openCopyCodeModal(bills)"
                            id="homeCopyLineCodeMobile"
                            class="btn-style btn-pay"
                            width="30.893"
                            height="30.893"
                        >
                          <em class="fa fa-copy icons-action"></em></button
                        >
                        <span style="margin-top: 10px"
                        >Copiar linha digitável</span
                        >
                      </div>
                      <div
                          class="row"
                          style="padding-top: 0px"
                          v-if="bills.documento_diverso"
                      >
                        <button
                            @click="downloadDocument(bills.cod_id)"
                            id="homeDownloadDocumentMobile"
                            class="btn-style btn-pay"
                            width="30.893"
                            height="30.893"
                        >
                          <em class="fa fa-copy icons-action"></em>
                          <span style="margin-top: 10px; margin-left: 7px"
                          >Download documento anexo</span
                          >
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="buttons-footer">
              <p class="total-page">
                Total de boletos: {{ this.pagination.total }}
              </p>
            </div>
            <!-- pagination of registered bills mobile screen -->

            <pagination
                v-if="pagination.last_page > 1"
                :pagination="pagination"
                :offset="5"
                @paginate="getBills(true)"
            ></pagination>
          </div>
          <button
              hidden
              id="homeDownloadBillGrid"
              class="btn btn-lg access"
              style="margin-right: 5px"
              type="submit"
              @click="
              renderBillsDownloadModal += 1;
              showBillsDownloadModal = true;
            "
              v-bind:disabled="!selected.length"
          >
            Download
          </button>
        </div>
        <!-- END OF MOBILE SCREEN -->
      </div>
    </div>
    <bills-download-modal
        v-if="showBillsDownloadModal"
        v-bind="billsModalProps"
        :key="renderBillsDownloadModal"
    ></bills-download-modal>

    <bills-reports-modal
        v-if="selected.length"
        v-bind="reportsProps"
        :key="renderReportsModal"
    ></bills-reports-modal>
    <pix-payment-modal
        v-bind="pixProps"
        :key="renderPixModal"
        v-if="showPixModal"
        @addPixArray="addPixArray"
        @allowGetPix="pixWait = false"
    ></pix-payment-modal>
    <notification-email-modal
        v-bind="notificationEmailProps"
        :key="renderNotificationEmailModal"
        v-if="showNotificationEmailModal"
    ></notification-email-modal>
    <copy-code-modal
        v-bind="CopyCodeProps"
        :key="renderCopyCodeModal"
        v-if="showCopyCodeModal"
    ></copy-code-modal>

    <footer-nav></footer-nav>
  </div>
</template>

<script>
import NavBar from "../../../common/components/NavBar";
import Preload from "../../../common/components/Preload";
import axios from "axios";
import PrivacyPolicyConsent from "../../../common/components/PrivacyPolicyConsent";
import FooterNav from "../../../common/components/FooterNav";
import Pagination from "../../../common/components/Pagination";
import BillsReportsModal from "./bill/BillsReportsModal";
import NotificationEmailModal from "./bill/NotificationEmailModal";
import BillsDownloadModal from "./bill/BillsDownloadModal";
import Vue from "vue";
import moment from "moment";
import BillsAction from "./bill/BillsAction";
import PixPaymentModal from "./pix/PixPaymentModal";
import CopyCodeModal from "./bill/CopyCodeModal";
import NpsIndecx from "../../../common/components/npsIndecx.vue";

export default {
  name: "Home",
  components: {
    NavBar,
    Preload,
    PrivacyPolicyConsent,
    FooterNav,
    Pagination,
    BillsReportsModal,
    NotificationEmailModal,
    BillsDownloadModal,
    PixPaymentModal,
    CopyCodeModal,
    NpsIndecx,
  },
  data() {
    return {
      boletos: [],
      pagination: {
        current_page: 1,
      },
      preload: false,
      filters: {
        documento: "",
        cedente: "",
        sacado: "",
        nosso_numero: "",
        vencimento_inicial: "",
        vencimento_final: "",
        status: "",
        cdt_id: "",
        mensagem: "",
      },
      currentSort: "",
      currentSortDir: "asc",
      buttonChecked: "",
      STATUS_KEY: {
        2: "Registrado",
        3: "Liquidado",
        4: "Baixado",
        6: "Protestado",
        8: "Liquidado parcial",
      },
      billTypes: {},
      groupFilters: {},
      userLogged: JSON.parse(localStorage.userLogged),
      bill: "",
      renderActionModal: Math.random(),
      renderBillsDownloadModal: Math.random(),
      renderPixModal: Math.random(),
      renderNotificationEmailModal: Math.random(),
      renderCopyCodeModal: Math.random(),
      renderReportsModal: Math.random(),
      showActionModal: false,
      showPixModal: false,
      showNotificationEmailModal: false,
      showCopyCodeModal: false,
      showBillsDownloadModal: false,
      billsModalProps: {},
      selected: [],
      blockDateBefore: "",
      blockDateAfter: "",
      billDownloadPermission: [2, 8],
      downloadIsvencido: false,
      haveActionsTd: false,
      cachedPIX: [],
      pixWait: false,
      pixModal: {},
    };
  },

  methods: {
    getBills(paginate = false) {
      this.preload = true;
      if (!paginate) {
        this.clearPagination();
      }
      axios
          .get(
              `${process.env.API_PBM}/boletos?page=${this.pagination.current_page}`,
              {
                params: this.filters,
              }
          )
          .then((response) => {
            this.boletos = response.data.data.boletos;
            if (this.boletos) {
              this.haveActions();
              this.pagination = response.data.data.pagination;
              this.preload = false;
              return;
            }
            this.clearPagination();
            this.preload = false;
          })
          .catch((error) => {
            Vue.$toast.error("Ops! Não foi possível buscar os dados.", {
              position: "top-right",
              duration: 5000,
            });
            this.preload = false;
          });
    },
    clearPagination() {
      this.pagination = {
        total: 0,
        per_page: 15,
        current_page: 1,
        last_page: 1,
        from: 0,
        to: 0,
      };
    },
    setFilter(filter, value, reset = false, buttonChecked = false) {
      if (reset) this.filters = {};
      if (buttonChecked) {
        this.buttonChecked = buttonChecked;
        this.filters.vencimento_inicial = "";
        this.filters.vencimento_final = "";
      }

      if (Array.isArray(filter)) {
        filter.forEach((val, index) => {
          this.filters[val] = value[index];
        });
      } else {
        this.filters[filter] = value;
      }
      this.selected = [];
      this.getBills();
    },
    removeFilter(filter) {
      delete this.filters[filter];
      if (filter === "status") {
        delete this.filters.vencimento_final;
        delete this.filters.vencimento_inicial;
      }
      this.selected = [];
      this.getBills();
      this.buttonChecked = "todos";
    },
    btnFilters(button) {
      const buttonFilters = {
        a_vencer: {
          status: [2, 8],
          vencimento_inicial: moment().format("YYYY-MM-DD"),
          order_by: "cod_dt_vencto;asc",
        },
        vencido: {
          status: [2, 8, 6],
          vencimento_final: moment().subtract(1, "day").format("YYYY-MM-DD"),
          order_by: "cod_dt_vencto;desc",
        },
        liquidado: {
          status: [3, 4],
        },
      };
      if (buttonFilters[button]) {
        this.setFilter(
            Object.keys(buttonFilters[button]),
            Object.values(buttonFilters[button]),
            false,
            button
        );
      }
      this.selected = [];
    },
    sort(field) {
      if (field === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = field;
      this.filters["order_by"] = `${field};${this.currentSortDir}`;
      this.getBills();
    },

    removeStatus(statusValue) {
      const index = this.filters.status.indexOf(statusValue);

      if (index > -1) {
        this.selected = [];
        this.filters.status.splice(index, 1);
        this.getBills();
      }
    },
    openCopyCodeModal(bill) {
      this.showCopyCodeModal = true;
      this.bill = bill;
      this.renderCopyCodeModal += 1;
    },
    openNotificationEmailModal(bill) {
      this.showNotificationEmailModal = true;
      this.bill = bill;
      this.renderNotificationEmailModal += 1;
    },
    openPixModal(bill, pix = {}) {
      this.showPixModal = true;
      this.pixModal = pix;
      this.bill = bill;
      this.renderPixModal += 1;
    },

    updateBlockDate() {
      this.blockDateBefore = this.filters.vencimento_inicial;
      this.blockDateAfter = this.filters.vencimento_final;
    },

    permissionDownloadBill(bill) {
      return this.billDownloadPermission.includes(bill.cst_id);
    },

    downloadBill(bill) {
      if (bill.is_vencido <= 0) {
        return BillsAction.download(bill.cod_id);
      }
      this.downloadIsvencido = bill;
      this.resetModalDownloadBill();
    },

    resetModalDownloadBill() {
      this.updateBillsModalProps();
      this.renderBillsDownloadModal += 1;
      this.showBillsDownloadModal = true;
    },

    copyCode(billId) {
      return BillsAction.copyCodeBills(billId);
    },

    downloadDocument(billId) {
      return BillsAction.downloadAttachedDocument(billId);
    },

    haveActions() {
      this.haveActionsTd = false;
      this.boletos.forEach((bills) => {
        if (
            bills.documento_diverso ||
            bills.pagamento_parcelado ||
            this.permissionDownloadBill(bills)
        ) {
          this.haveActionsTd = true;
        }
      });
    },

    getPix(bill) {
      //se já existe um pix gerado não gera outro
      for (var i = 0; i < this.cachedPIX.length; i++) {
        if (this.cachedPIX[i].cod_id === bill.cod_id) {
          return this.openPixModal(bill, this.cachedPIX[i]);
        }
      }

      if (this.pixWait) {
        Vue.$toast.warning("Aguarde! Estamos criando o PIX.", {
          position: "top-right",
          duration: 5000,
        });
        return;
      }

      this.pixWait = true;
      this.openPixModal(bill);
    },

    addPixArray(pix) {
      this.cachedPIX.push(pix);
      this.pixWait = false;
    },

    clearSelectCheck() {
      this.selected = [];
    },

    clearFilter() {
      this.filters.documento = "";
      this.filters.cedente = "";
      this.filters.sacado = "";
      this.filters.nosso_numero = "";
      this.filters.vencimento_inicial = "";
      this.filters.vencimento_final = "";
      this.filters.status = "";
      this.filters.cdt_id = "";
      this.filters.mensagem = "";
      this.btnFilters("a_vencer");
    },

    updateBillsModalProps() {
      let bills;
      if (this.downloadIsvencido) {
        bills = [this.downloadIsvencido];
        this.downloadIsvencido = false;
      } else {
        bills = this.boletos.filter((key) => {
          return this.selected.indexOf(key["cod_id"]) >= 0;
        });
      }

      this.billsModalProps = {bills, order_by: this.filters.order_by};
    },

    getFilters() {
      axios
          .get(
              `${process.env.API_PBM}/user/filters`
          )
          .then(({data}) => {
            this.billTypes = data.data.boletos.boleto_types;
            this.groupFilters = data.data.filtros;
          });
    },

  },

  computed: {
    pixProps() {
      return {
        pix: this.pixModal,
        bill: this.bill,
      };
    },
    CopyCodeProps() {
      return {
        bill: this.bill,
      };
    },
    notificationEmailProps() {
      return {
        bill: this.bill,
      };
    },
    reportsProps() {
      return {
        selected: this.selectAll ? this.selectAll : this.selected,
        filters: this.filters,
      };
    },
    selectAll: {
      get() {
        return this.boletos
            ? this.selected.length === this.boletos.length
            : false;
      },
      set(value) {
        var selected = [];

        if (value) {
          this.boletos.forEach(function (bills) {
            selected.push(bills.cod_id);
          });
        }

        this.selected = selected;
      },
    },
  },
  mounted() {
    this.$store.state.navBarActive = "boletos";
    this.btnFilters("a_vencer");
    document.body.style.backgroundImage = "none";
    this.getFilters();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
pre {
  font: inherit;
  color: rgb(100, 95, 95);
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit;
}

th:has(em) {
  background: blue;
}

.fa-sort-down {
  margin-left: 5px;
  cursor: pointer;
}

.fa-sort-up {
  margin-left: 5px;
  cursor: pointer;
}

table thead {
  background-color: #cacaca;
  color: rgb(100, 95, 95);
}

.table {
  position: relative;
}

.my-custom-scrollbar {
  position: relative;
  height: 400px;
  overflow: auto;
}

.table-wrapper-scroll-y {
  display: block;
}

.table thead th {
  position: sticky;
  top: 0;
  background-color: rgb(235, 231, 231) !important;
}

table tr {
  white-space: nowrap;
}

tbody {
  font-size: 12px;
  color: rgb(100, 95, 95);
}

.total-page {
  color: rgb(100, 95, 95);
  font-size: 14px;
}

.has-search .form-control-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  width: 2.375rem;
  height: 2.375rem;
  line-height: 2.375rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
}

.form-control {
  font-size: 14px;
  color: grey;
}

.icons-font {
  font-size: 19px;
}

.icons-btn {
  background-color: #fff;
  cursor: pointer;
  border: none;
}

.btn {
  line-height: 1rem;
}

.btn-filter {
  color: #424242;
  background-color: #fff;
  border: 1px solid #ebe7e7;
  width: 120px;
}

.btn-filter:hover {
  color: #fff !important;
  background-color: #9c9a9a;
  border: 1px solid #ebe7e7;
}

.btn-checked {
  color: #fff;
  background-color: #9c9a9a;
  border: 1px solid #ebe7e7;
}

.contact {
  padding: 4%;
}

.row {
  padding-top: 30px;
}

.contact-info h2 {
  margin-bottom: 10%;
}

.col-md-12 {
  background: #fff;
  padding: 3%;
  border-radius: 0.2rem;
}

.contact-form label {
  font-weight: 600;
}

.page-user {
  font-size: 18px;
  margin-top: -5px;
}

label {
  font-size: 15px;
  color: rgb(100, 95, 95);
}

.form-group input,
textarea {
  background-color: #fff;
  margin-bottom: 10px;
  margin-top: -8px;
  line-height: 1rem;
  font-size: 14px;
}

.btn:focus {
  box-shadow: none !important;
}

.access {
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 12px;
}

.access-filter {
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 15px;
  height: 33px;
  width: 13% !important;
}

.form-filter-mobile {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.selectpicker {
  height: 30px;
  font-size: 13px;
  color: rgb(100, 95, 95);
  width: 73%;
}

.buttons-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}

.contact-form button:focus {
  box-shadow: none;
}

.status-filter {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.dropdown {
  position: inherit;
}

.dropdonw-menu.show {
  padding: 10px;
}

.loading_pix {
  width: 200px;
  height: 150px;
  overflow: hidden;
}

.loading_pix img {
  width: 800px;
  margin: -252px 0 0 -335px;
}

.span_background_2 {
  background-color: #f3eb04;
  border-radius: 80px;
  padding: 0px 3px 0px 6px;
}

.span_background_3 {
  background-color: #20a031;

  border-radius: 80px;
  padding: 0px 3px 0px 6px;
}

.span_background_4 {
  background-color: #42ea57;

  border-radius: 80px;
  padding: 0px 3px 0px 6px;
}

.span_background_6 {
  background-color: #bf0c0c;

  border-radius: 80px;
  padding: 0px 3px 0px 6px;
}

.span_background_8 {
  background-color: #fecb51;

  border-radius: 80px;
  padding: 0px 3px 0px 6px;
}

.icons-action {
  font-size: 20px;
  margin-top: 5px;
  color: rgb(100, 95, 95);
  cursor: pointer;
}

.icon-payment {
  font-size: 20px;
  cursor: pointer;
}

.action-text-style-checked {
  cursor: pointer;
  color: rgb(100, 95, 95);
}

.credit-payment-yellow {
  cursor: pointer;
  color: #dbc50b;
}

.credit-payment-yellow-status {
  cursor: pointer;
  color: rgb(100, 95, 95);
}

.credit-payment-green {
  cursor: pointer;
  color: #3dd20b;
}

.credit-payment-green-status {
  cursor: pointer;
  color: rgb(100, 95, 95);
}

.credit-payment-blue-status {
  cursor: no-drop;
  color: rgb(100, 95, 95);
}

.credit-payment-blue {
  cursor: no-drop;
  color: #0b7adb;
}

.btn-style {
  border: none !important;
  background-color: transparent !important;
  cursor: pointer;
  color: rgb(100, 95, 95);
  text-align: initial;
}

.dropdown-item {
  font-size: 13px;
  color: rgb(100, 95, 95);
  width: 100%;
}

.dropdown-menu {
  box-shadow: 0px 0px 7px gray !important;
  padding: 5px 0px 5px 0px;
}

.select-pp {
  margin-bottom: 10px;
  margin-top: -8px;
  height: 2rem !important;
}

@media only screen and (max-width: 900px) {
  .class-mobile {
    display: flex !important;
    width: 100%;
    margin: 0 auto;
  }

  .class-desktop {
    display: none !important;
  }

  .col-md-8 {
    background: #ebe7e7;
    padding: 3%;
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }

  .buttons-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 25px;
  }

  .access {
    color: #fff;
    border-radius: 6px;
    width: 45%;
    height: 70%;
    font-size: 11px;
    cursor: pointer;
    padding: 5px;
    font-size: 12px;
    text-align: center;
  }

  .page-user {
    font-size: 20px;
    display: flex;
    justify-content: center;
  }

  .btn-filter {
    color: #424242;
    background-color: #fff;
    border: 1px solid #ebe7e7;
    font-size: 14px;
    line-height: 1;
    width: 35%;
    cursor: pointer;
  }

  .btn-filter:hover {
    color: #fff !important;
    background-color: #9c9a9a;
    border: 1px solid #ebe7e7;
  }

  .btn-checked {
    color: #fff;
    background-color: #9c9a9a;
    border: 1px solid #ebe7e7;
  }

  .table {
    margin-top: 35px;
    background-color: #fff;
  }

  .hiddenRow {
    padding: 0 !important;
  }

  label {
    display: inline-block;
    font-size: 13px;
    color: #424242;
  }

  .icons-font {
    font-size: 18px;
    cursor: pointer;
  }

  .col-divs {
    display: inline-flex;
    margin: 0 auto;
    font-size: 11px;
  }

  .principal-div {
    margin-top: 20px;
    background-color: #fff;
    border-radius: 6px;
    padding: 5px;
    color: rgb(100, 95, 95);
  }

  .access-filter {
    color: #fff;
    border-radius: 6px;
    cursor: pointer;
    padding: 5px;
    font-size: 15px;
    height: 33px;
    width: 30% !important;
  }
}

.class-mobile {
  display: none;
}

@media only screen and (max-width: 800px) and (min-width: 768px) {
  .ipad-media {
    margin-left: -45px;
  }
}

@media only screen and (max-width: 414px) and (min-width: 412px) {
  .ipad-media {
    margin-left: -5px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/components/home/Home.vue